// File: src/components/common/AccountStatusListener.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

const AccountStatusListener = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    useEffect(() => {
        const socket = io(API_URL);
        const token = localStorage.getItem('skillmatch_token');
        let currentUserId = null;

        // Decode token để lấy userId hiện tại (đơn giản, không cần thư viện)
        if (token) {
            try {
                const payload = JSON.parse(atob(token.split('.')[1]));
                currentUserId = payload.user.id;
            } catch (e) {}
        }

        if (currentUserId) {
            socket.on('server:force_logout', (data) => {
                // Kiểm tra xem sự kiện có dành cho user này không
                if (data.userId === currentUserId) {
                    localStorage.removeItem('skillmatch_token'); // Xóa token ngay lập tức
                    
                    if (data.reason === 'deleted') {
                        setModal({
                            show: true,
                            title: 'Tài khoản đã bị xóa',
                            message: 'Admin đã xóa tài khoản của bạn khỏi hệ thống. Bạn sẽ được chuyển về trang chủ.'
                        });
                    } else if (data.reason === 'locked') {
                        setModal({
                            show: true,
                            title: 'Tài khoản bị khóa',
                            message: 'Tài khoản của bạn đã bị khóa do vi phạm chính sách. Vui lòng liên hệ hỗ trợ.'
                        });
                    }
                }
            });
        }

        return () => socket.disconnect();
    }, []);

    const handleClose = () => {
        setModal({ show: false, title: '', message: '' });
        navigate('/login'); // Đá về trang login
    };

    if (!modal.show) return null;

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: 'white', padding: '30px', borderRadius: '16px', width: '350px', textAlign: 'center', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚫</div>
                <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#DC2626', marginBottom: '12px' }}>{modal.title}</h3>
                <p style={{ fontSize: '15px', color: '#4B5563', marginBottom: '24px', lineHeight: '1.5' }}>{modal.message}</p>
                <button 
                    onClick={handleClose}
                    style={{ width: '100%', padding: '12px', background: '#DC2626', color: 'white', fontWeight: 'bold', borderRadius: '8px', border: 'none', cursor: 'pointer' }}
                >
                    Đã hiểu & Đăng xuất
                </button>
            </div>
        </div>
    );
};

export default AccountStatusListener;